import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Navbar, Footer } from "../components/Layout";
import { Check, Clock, AlertCircle } from "lucide-react";
import { useText } from "../contexts/TextsContext";

export default function PaymentSuccess() {
  const [search] = useSearchParams();
  const sessionId = search.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending", status: "open" });
  const [attempts, setAttempts] = useState(0);
  const [done, setDone] = useState(false);
  const t = useText();

  useEffect(() => {
    if (!sessionId || done) return;
    let active = true;
    const poll = async (n) => {
      if (!active) return;
      if (n >= 7) { setDone(true); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (!active) return;
        setStatus(data);
        if (data.payment_status === "paid" || data.status === "expired") {
          setDone(true);
          return;
        }
      } catch (err) { console.error("Payment status poll failed:", err); }
      setAttempts(n + 1);
      setTimeout(() => poll(n + 1), 2000);
    };
    poll(0);
    return () => { active = false; };
  }, [sessionId, done]);

  const paid = status.payment_status === "paid";
  const expired = status.status === "expired";

  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <Navbar />
      <section className="max-w-3xl mx-auto px-6 md:px-8 py-24 text-center" data-testid="payment-success-page">
        {paid ? (
          <>
            <div className="w-20 h-20 bg-[#FFC107] border border-slate-900 flex items-center justify-center mx-auto mb-8">
              <Check className="w-10 h-10" strokeWidth={3} />
            </div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FFC107] mb-4">{t("payment.kicker")}</div>
            <h1 className="font-display font-black text-4xl md:text-5xl tracking-tight mb-6">{t("payment.success.title")}</h1>
            <p className="text-slate-600 mb-10">{t("payment.success.desc")}</p>
          </>
        ) : expired ? (
          <>
            <div className="w-20 h-20 bg-red-100 border border-slate-900 flex items-center justify-center mx-auto mb-8">
              <AlertCircle className="w-10 h-10" strokeWidth={2.5} />
            </div>
            <h1 className="font-display font-black text-4xl tracking-tight mb-6">{t("payment.expired.title")}</h1>
            <p className="text-slate-600 mb-10">{t("payment.expired.desc")}</p>
          </>
        ) : (
          <>
            <div className="w-20 h-20 bg-white border border-slate-900 flex items-center justify-center mx-auto mb-8 animate-pulse">
              <Clock className="w-10 h-10" />
            </div>
            <h1 className="font-display font-black text-4xl tracking-tight mb-6">{t("payment.pending.title")}</h1>
            <p className="text-slate-600 mb-10 font-mono text-sm">Tentative {attempts + 1}/7</p>
          </>
        )}
        <Link to="/" className="btn-brutal btn-brutal-solar inline-block px-8 py-4 font-bold uppercase tracking-wider text-sm" data-testid="success-back-home">{t("global.back_home")}</Link>
      </section>
      <Footer />
    </div>
  );
}
